var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeSquareDesign2X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1325.792,
    height: 1272.792,
    viewBox: "0 0 1325.792 1272.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-1717.604 -985.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_3",
    "data-name": "Path 3",
    transform: "translate(2354 985.604) rotate(45)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H900V900H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 4 4 L 4 896 L 896 896 L 896 4 L 4 4 M 0 0 L 900 0 L 900 900 L 0 900 L 0 0 Z",
    stroke: "none",
    fill: "coral"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_66",
    "data-name": "Rectangle 66",
    transform: "translate(2407 985.604) rotate(45)",
    fill: "none",
    stroke: "coral",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 900,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 896,
    height: 896,
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeSquareDesign2X);
export default __webpack_public_path__ + "static/media/orangeSquareDesign2x.042f89bab582dee86fa02d5fa44789c2.svg";
export { ForwardRef as ReactComponent };